import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation, faCircleNotch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { faHourglassHalf } from '@fortawesome/free-regular-svg-icons';
import { useNavigate } from 'react-router-dom';
import { DocumentViewer } from '@cbojs/pdf-viewer';
import BlurModal from '../blurModal/BlurModal';
import { PrimaryButton } from '../button/Button';

import styles from './ReportPreview.module.scss';
import fontStyles from '../text/Text.module.css';
import { s } from '../../app/helper';
// import { getDocument } from '../../reducer/documentSlice';
// import { getPdf } from '../../reducer/pdfSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { get2Pdfs, selectPdfsSlice } from '../../reducer/pdfSlice';
import { selectActiveReport } from '../../reducer/reportsSlice';

const ReportPreview: React.FC<{ onHide: () => void }> = ({ onHide }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const pdfState = useAppSelector(selectPdfsSlice);
  const report = useAppSelector(selectActiveReport);

  const [t] = useTranslation('report_preview');

  useEffect(() => {
    const get2PdfsPromise = dispatch(get2Pdfs());
    return () => get2PdfsPromise.abort();
  }, [dispatch]);

  let reportId: string;
  const documents = { en: {}, de: {} };
  if (pdfState.status === 'success') {
    const { en, de } = pdfState.data;
    documents.en = en.startsWith('data:application/pdf;base64,') ? { pdfBase64: en } : { pdfUrl: en };
    documents.de = de.startsWith('data:application/pdf;base64,') ? { pdfBase64: de } : { pdfUrl: de };
    reportId = pdfState.currentJobId;
  }

  return (
    <BlurModal
      show
      backdropClassName={styles.reportPreviewBackdrop}
    >
      <Col
        xs={{ span: 8, offset: 2 }}
        lg={{ span: 10, offset: 1 }}
        className={styles.reportPreviewContainer}
      >
        <Row className={s(
          styles.reportPreviewTitle,
          fontStyles.HeaderPopups,
        )}
        >
          {t('preview')}
        </Row>
        <Row className={s(
          styles.reportPreviewSubTitle,
          fontStyles.SubHeaderPopups,
        )}
        >
          {report?.company}
          &nbsp;
          {t('report')}
        </Row>
        <Row className={styles.reportPreviewPdf}>
          <PrimaryButton
            className={styles.closePreviewModal}
            onClick={onHide}
          >
            <FontAwesomeIcon
              icon={faTimes}
              size="2x"
            />
          </PrimaryButton>
          {
            pdfState.status === 'success'
              ? (
                <div className="d-flex justify-content-center">
                  <DocumentViewer
                    document={documents.en}
                    className={s(styles.pdfPreviewer, 'w-50 p-1')}
                    allowBlobInspectionMode={false}
                  />
                  <DocumentViewer
                    document={documents.de}
                    className={s(styles.pdfPreviewer, 'w-50 p-1')}
                    allowBlobInspectionMode={false}
                  />
                </div>
              ) : (
                <>
                  <FontAwesomeIcon
                    icon={{
                      error: faCircleExclamation,
                      // success: faCircleExclamation,
                      idle: faHourglassHalf,
                      loading: faCircleNotch,
                    }[pdfState.status]}
                    color="white"
                    size="3x"
                    spin={pdfState.status === 'loading'}
                  />
                  <div className={s(styles.reportPreviewError, fontStyles.SubHeaderPopups)}>
                    {/* {reportState.status === 'error' && `REPORT: ${t('error-loading')}`} */}
                    {/* <br /> */}
                    {pdfState.status === 'error' && `PDF: ${t('error-loading')}`}
                  </div>
                </>
              )
          }
        </Row>
        <Row className={styles.reportPreviewButtonContainer}>
          <PrimaryButton
            className={styles.reportPreviewButton}
            onClick={() => {
              navigate(`/report/${reportId}/`);
            }}
          >
            {t('select-document')}
          </PrimaryButton>
        </Row>
      </Col>
    </BlurModal>
  );
};

export default ReportPreview;
